import React, {Fragment} from "react";
import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../../../utils/formatters";
import CheckBox from "../../../../form/CheckBox";
import {Tooltip} from "react-tippy";
import ImportButton from "../../../../form/ImportButton";

const sortable = true;
const filterable = true;

export default class DiffView extends React.Component {

    refresh = () => {
        this.items.refresh();
    }

    refreshBackground = () => {
        this.items.refreshBackground();
    }

    render() {
        const label = this.props.user.hasPermission("change_inventory") ? "Tételek" : "Eltérések";
        return (
            <Fragment>
                <div className="form-group">
                    <label className="control-label">{label}</label>
                    <SelectorGrid
                        ref={(e) => this.items = e}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", params: {name: ((this.props.values.label ? this.props.values.label + " - " : "") + label)}}]}
                        {...this.props.props.pool}
                        parameters={{...this.props.props.pool.parameters, inventory: !this.props.user.hasPermission("change_inventory") ? true : this.props.check}}
                        paginatorRight={this.props.user.hasPermission("change_inventory") ? (props) => <Fragment>
                            <Tooltip title={!this.props.check ? "Csak az eltérések mutatása" : "Mindent mutat"}>
                                <CheckBox
                                    onIcon={{lib: "fa", name: "box"}}
                                    offIcon={{lib: "fa", name: "box-open"}}
                                    value={this.props.check}
                                    label={false}
                                    saveChanges={() => {
                                        this.props.swapCheck();
                                    }}
                                    {...props}
                                />
                            </Tooltip>
                            <ImportButton
                                {...this.props.getFieldProps("import")}
                                data={this.props.values}
                                disabled={!this.props.values[this.props.componentConfig.idfield]}
                                componentConfig={this.props.componentConfig}
                                label={false}
                                name="file"
                                saveChanges={this.props.importFile}
                                {...props}
                            />
                        </Fragment>: null}
                        aggregations={null}
                        onItemUpdate={this.props.user.hasPermission("change_inventory") ? async (item, oldItem, field) => await this.props.parent.onSourceItemUpdate(item, oldItem, field) : null}
                        columns={{
                            "displayname": {
                                ...ProductColumn("component_id"),
                                width: 7,
                            },
                            "barcode": {
                                header: 'Vonalkód',
                                width: 1,
                                sortable,
                                filterable
                            },
                            "listprice": {
                                header: 'Lista ár',
                                width: 1,
                                sortable,
                                filterable,
                                renderer: CurrencyFormatter,
                                className: "currency"
                            },
                            "stockqty": {
                                header: 'Raktárkészlet',
                                width: 1,
                                sortable,
                                filterable,
                                aggregation: (value, row) => UnitFormatter(value || 0, row.unit),
                                className: "unit",
                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                            },
                            "pickedqty": this.props.props.pool.columns.pickedqty,
                        }}
                    />
                </div>
            </Fragment>
        );
    }
}